// extracted by mini-css-extract-plugin
export var closeButton = "_i4-1";
export var closeX = "_i4-3";
export var container = "_i4-0";
export var image = "_i4-2";